import React, { Component } from 'react';
import FileUploaderBlob from './../../../commons/FileUploaderBlob.js';
import DownloadFile from './../../../commons/DownloadFile.js';
import ErrorBox from './../../../commons/ErrorBox.js';

export default class ProductInfraCapacityMapping extends Component {
	constructor(props) {
		super(props);
		this.state = { error: null };
		this.showDownloadError = this.showDownloadError.bind(this);
		this.closeError = this.closeError.bind(this);
	}

	showDownloadError(error) {
		this.setState({ error: (error && error.message) ? error.message : 'Failed to download template.' });
	}

	closeError() {
		this.setState({ error: null });
	}

	render() {
		return(
			<div className="dump-ingestion-wrapper">
				<div className="white-box">
					<div className="page-header-title">
						Product Infra Capacity Mapping
					</div>
					<div>
						<DownloadFile title="Download Product Infra Capacity Mapping Template" url="ingest/product-infra-capacity-mapping/template" errorCallback={this.showDownloadError}/>
					</div>
					<div className="top-thirty">
						<FileUploaderBlob url="ingest/product-infra-capacity-mapping"/>
					</div>
				</div>
				{(this.state.error) ?
					<ErrorBox errorText={this.state.error} closeError={this.closeError} /> : null
				}
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/screens/DynamicSpaceAllocation/Components/ProductInfraCapacityMapping.js